import { createContext } from "react";
import { FormProps, Form as RouterForm } from "react-router-dom";
import { toSnake } from "ts-case-convert";

interface Props extends FormProps {
  resource: string;
}

export const FormContext = createContext<{ resource: string }>({ resource: "" });

export const Form = ({ children, resource, ...props }: Props) => {
  return (
    <FormContext.Provider value={{ resource: toSnake(resource) }}>
      <RouterForm {...props}>{children}</RouterForm>
    </FormContext.Provider>
  );
};
